var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-common-selector" }, [
    _c(
      "div",
      { staticClass: "clearfix font-size-14" },
      [
        _c(
          "div",
          { staticClass: "pull-left" },
          [
            _vm.type === -1
              ? _c(
                  "yxt-select",
                  {
                    staticClass: "mr12",
                    staticStyle: { width: "144px" },
                    attrs: { clearable: "", placeholder: _vm.typePlaceholder },
                    on: {
                      change: function ($event) {
                        return _vm.getList(true)
                      },
                    },
                    model: {
                      value: _vm.commonType,
                      callback: function ($$v) {
                        _vm.commonType = $$v
                      },
                      expression: "commonType",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("yxt-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c("yxt-input", {
          staticClass: "pull-left",
          staticStyle: { width: "240px" },
          attrs: {
            placeholder: _vm.searchPlaceholder,
            searchable: "",
            maxlength: "50",
          },
          on: { search: _vm.search },
          model: {
            value: _vm.searchParam.keyword,
            callback: function ($$v) {
              _vm.$set(_vm.searchParam, "keyword", $$v)
            },
            expression: "searchParam.keyword",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "yxtbiz-common-selector__main mt16" },
      [
        _c(
          "yxt-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "stb",
            staticClass: "yxtbiz-common-selector__table",
            attrs: {
              data: _vm.list,
              height: _vm.tableHeight,
              "default-sort": { prop: "updateTime", order: "desc" },
            },
            on: {
              "select-all": _vm.selectAll,
              select: _vm.select,
              "sort-change": _vm.sortChange,
            },
          },
          [
            !_vm.isSingle
              ? _c("yxt-table-column", {
                  attrs: {
                    "show-overflow-tooltip": false,
                    "class-name": "yxtbiz-table-selection",
                    type: "selection",
                    width: "39",
                  },
                })
              : _vm._e(),
            _vm._l(_vm.columns, function (column, index) {
              return _c("yxt-table-column", {
                key: index,
                attrs: {
                  prop: column.name,
                  label: column.label || column.name,
                  width: column.width,
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.multiColumn(
                                  column.isCombined ? column.factors : [column],
                                  scope.row
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            _vm.isSingle
              ? _c("yxt-table-column", {
                  attrs: { label: "操作", width: "100", align: "left" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "yxt-link",
                              {
                                attrs: { underline: false, type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectRow(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.value &&
                                      (_vm.value.id === scope.row.id ||
                                        (_vm.value[0] &&
                                          _vm.value[0].id === scope.row.id))
                                      ? "取消选择"
                                      : "选择"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1886798323
                  ),
                })
              : _vm._e(),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "mt16 clearfix pr" },
          [
            _c("yxt-pagination", {
              staticClass: "pull-right",
              attrs: {
                "page-size": _vm.searchParam.limit,
                total: _vm.count,
                "current-page": _vm.page,
                layout: "total, prev, pager, next",
              },
              on: {
                "current-change": _vm.pageChange,
                "size-change": _vm.sizeChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }